import { Dialog, Button, Box, Text, Stack } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { usePersonaIdVerification } from '@/features/Persona'
import IdVerification from './illustration/id-verification.svg?react'

type Props = {
  visible: boolean
  onClose: () => void
}

const IdVerificationRequiredModal = ({ visible, onClose }: Props) => {
  const { t } = useTranslation()
  const personaIdVerification = usePersonaIdVerification()

  const Description = () => {
    return (
      <Stack align="center" space="gutter">
        <Text align="center" tone="secondary">
          {t(
            'l.standalone_trustscore.form_verification_required_description',
            'We require additional information to verify your account before you can continue using the Trust Score.'
          )}
        </Text>
        <Text align="center" tone="secondary">
          {t(
            'l.standalone_trustscore.form_verification_required_sub_description',
            'Please help us keep our community safe – it only takes a few minutes.'
          )}
        </Text>
      </Stack>
    )
  }

  const handleOnStart = async () => {
    onClose()
    personaIdVerification({})
  }

  return (
    <Dialog
      id="id-verification-required-modal"
      open={visible}
      onClose={onClose}
      width="xsmall"
      title={t(
        'l.standalone_trustscore.form_verification_required_title',
        'ID Verification Needed'
      )}
      illustration={<IdVerification />}
      description={<Description />}
      hideXButton
    >
      <Box display="flex" alignItems="center" gap="xsmall" width="full">
        <Button variant="solid" onClick={handleOnStart}>
          {t('l.standalone_trustscore.form_verification_required_button_start', 'Get Started')}
        </Button>
      </Box>
    </Dialog>
  )
}

export default IdVerificationRequiredModal
